import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import { selectModalState, setCommonModalState } from '../../../../store/slices/commonModalSlice'
import { CommonModals } from '../../../types/enums'

export const useFilter = () => {
  const dispatch = useDispatch()
  const expanded = useSelector((state: RootState) => selectModalState(state, CommonModals.FILTER))

  const setFilterState = (state: boolean) =>
    dispatch(setCommonModalState({ modal: CommonModals.FILTER, state }))

  const toggleExpanded = () => {
    if (expanded) {
      setFilterState(false)
      return
    }
    setFilterState(true)
  }

  return { expanded, toggleExpanded }
}
